import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';
import { tournamentService } from '@/services/tournament';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useTournamentMedalEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        rank: null,
        image: null,
        imageFile: null
    });

    const validations = {
        name: { required },
        rank: { required, integer, min: minValue(0) },
        imageFile: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => tournamentService.medal.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_TOURNAMENT.MEDAL.INDEX })
    });

    const actions = {
        update: crudAction.executeAction({
            validator: v$,
            request: () => tournamentService.medal.update(model.id, model.name, model.rank, model.imageFile),
            onSuccess: () => router.push({ name: ROUTE_NAME_TOURNAMENT.MEDAL.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
